import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Przycisk } from './ui';

interface Pozycja { do: string; etykieta: string; uprawnienie?: string; }

const MENU: { grupa: string; pozycje: Pozycja[] }[] = [
  {
    grupa: 'Praca',
    pozycje: [{ do: '/', etykieta: 'Pulpit' }],
  },
  {
    grupa: 'Magazyn',
    pozycje: [
      { do: '/stany', etykieta: 'Stany magazynowe', uprawnienie: 'kartoteka.odczyt' },
      { do: '/dokumenty', etykieta: 'Dokumenty', uprawnienie: 'kartoteka.odczyt' },
    ],
  },
  {
    grupa: 'Dydaktyka',
    pozycje: [
      { do: '/zajecia', etykieta: 'Zajęcia', uprawnienie: 'zajecia.odczyt' },
      { do: '/zestawy', etykieta: 'Zestawy', uprawnienie: 'zestawy.odczyt' },
      { do: '/rezerwacje', etykieta: 'Rezerwacje', uprawnienie: 'rezerwacje.odczyt' },
    ],
  },
  {
    grupa: 'Kartoteka',
    pozycje: [
      { do: '/kartoteka', etykieta: 'Materiały i typy', uprawnienie: 'kartoteka.odczyt' },
      { do: '/sprzet', etykieta: 'Sprzęt', uprawnienie: 'sprzet.odczyt' },
      { do: '/partie', etykieta: 'Partie i terminy', uprawnienie: 'kartoteka.odczyt' },
      { do: '/lokalizacje', etykieta: 'Lokalizacje' },
      { do: '/slowniki', etykieta: 'Słowniki', uprawnienie: 'kartoteka.zapis' },
    ],
  },
  {
    grupa: 'Kontrola',
    pozycje: [
      { do: '/serwis', etykieta: 'Przeglądy i serwis', uprawnienie: 'serwis.odczyt' },
      { do: '/inwentaryzacja', etykieta: 'Inwentaryzacja', uprawnienie: 'inwentaryzacja.spis' },
      { do: '/etykiety', etykieta: 'Etykiety i skaner' },
      { do: '/raporty', etykieta: 'Raporty', uprawnienie: 'raporty.odczyt' },
      { do: '/eksporty', etykieta: 'Eksport do Excela', uprawnienie: 'raporty.eksport' },
    ],
  },
  {
    grupa: 'Administracja',
    pozycje: [
      { do: '/uzytkownicy', etykieta: 'Użytkownicy', uprawnienie: 'uzytkownicy.zarzadzanie' },
      { do: '/role', etykieta: 'Role i uprawnienia' },
      { do: '/dziennik', etykieta: 'Dziennik operacji', uprawnienie: 'dziennik.odczyt' },
    ],
  },
];

export function Uklad() {
  const { uzytkownik, wyloguj, maUprawnienie } = useAuth();

  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <aside className="shrink-0 border-b border-kamien-200 bg-white lg:w-64 lg:border-b-0 lg:border-r">
        <div className="px-5 py-5">
          <p className="text-[10px] font-medium uppercase tracking-widest text-bordo-600">
            Collegium Medicum
          </p>
          <p className="mt-0.5 text-lg font-semibold text-kamien-900">Magazyn CSM</p>
        </div>

        <nav className="px-3 pb-4">
          {MENU.map((sekcja) => {
            const widoczne = sekcja.pozycje.filter(
              (p) => !p.uprawnienie || maUprawnienie(p.uprawnienie),
            );
            if (widoczne.length === 0) return null;
            return (
              <div key={sekcja.grupa} className="mb-4">
                <p className="px-2 pb-1.5 text-[11px] font-medium uppercase tracking-wide text-kamien-400">
                  {sekcja.grupa}
                </p>
                <ul className="flex flex-col gap-0.5">
                  {widoczne.map((p) => (
                    <li key={p.do}>
                      <NavLink
                        to={p.do}
                        end={p.do === '/'}
                        className={({ isActive }) =>
                          `block rounded-md px-2 py-2 text-sm transition-colors ${
                            isActive
                              ? 'bg-bordo-50 font-medium text-bordo-700'
                              : 'text-kamien-700 hover:bg-kamien-100'
                          }`
                        }
                      >
                        {p.etykieta}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </nav>

        <div className="border-t border-kamien-200 px-5 py-4 lg:mt-auto">
          <p className="text-sm font-medium text-kamien-900">{uzytkownik?.fullName}</p>
          <p className="text-xs text-kamien-500">{uzytkownik?.roleNazwa}</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <NavLink
              to="/haslo"
              className="text-xs text-kamien-600 underline underline-offset-2 hover:text-bordo-600"
            >
              Zmień hasło
            </NavLink>
            <Przycisk
              wariant="cichy"
              className="min-h-8 px-2 text-xs"
              onClick={() => void wyloguj()}
            >
              Wyloguj
            </Przycisk>
          </div>
        </div>
      </aside>

      <main className="flex-1 px-5 py-6 lg:px-8 lg:py-8">
        <div className="mx-auto max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
